





















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
// Components
import DatePicker from 'vue2-datepicker';
// Constants
import { formatDate, formatDate2 } from '@common/app.config';
// Icons
import iconCalendar from '@/assets/img/icon-calendar.svg';
import moment from 'moment-timezone';

@Component({
  components: {
    DatePicker,
  },
})
export default class BaseDatePicker extends Vue {
  @Prop(String) readonly value!: string;
  @Prop(String) readonly date!: string;
  @Prop(String) readonly errorText!: string;
  @Prop({ default: formatDate2 }) readonly format!: string;
  @Prop({ default: '入力してください' }) readonly placeholder!: string;
  @Prop({ default: 'date' }) readonly type!: string;
  @Prop({ default: formatDate }) readonly valueType!: string;
  @Prop(String) readonly labelText!: string;
  @Prop(Number) readonly minuteStep!: number;
  @Prop(Boolean) readonly showSecond!: boolean;
  @Prop(Boolean) readonly editable!: boolean;
  @Prop(Boolean) readonly disabled!: boolean;
  @Prop(Boolean) readonly disabledDates!: boolean;
  @Prop(Boolean) readonly disabledEqualOrBeforeToday!: boolean;
  @Prop(Boolean) readonly disabledBeforeToday!: boolean;
  @Prop(Boolean) readonly disabledBeforeTimeToday!: boolean;
  @Prop(Array) readonly hourOptions!: any;
  @Prop(Array) readonly minuteOptions!: any;
  @Prop({default: true}) readonly clearable!: boolean;
  @Prop({default: false, type: Boolean}) readonly showIconClear!: boolean;
  @Prop({default: false, type: Boolean}) readonly isFormStyle!: boolean;
  @Prop(Function) readonly renderDisabledDates!: (date) => void;
  @Prop({ default: false, type: Boolean }) readonly appendToBody!: boolean;

  iconCalendar: any = iconCalendar;

  get refDatePicker() {
    const ref = this.$refs.datePicker as any;
    return ref;
  }

  get checkBeforeTimeToday() {
    if (!this.date) {
      return true;
    }
    const today = moment().startOf('day');
    const givenDate = moment(this.date).startOf('day');
    return givenDate.isBefore(today);
  }

  get disabledInput() {
    if (this.disabled) {
      return this.disabled;
    }
    if (this.disabledBeforeTimeToday) {
      return this.checkBeforeTimeToday;
    }
  }

  disabledDatePicker(date) {
    if (this.disabledDates) {
      return this.renderDisabledDates(date);
    }
    if (this.disabledEqualOrBeforeToday) {
      return this.checkEqualOrBeforeToday(date);
    }
    if (this.disabledBeforeToday) {
      return this.checkBeforeToday(date);
    }
  }

  checkEqualOrBeforeToday(date) {
    const today = moment().startOf('day');
    const givenDate = moment(date).startOf('day');
    return givenDate.isBefore(today);
  }

  hoursAble(date) {
    const today = moment();
    const givenDate = moment(date);

    if (givenDate.isSame(today, 'day') && date) {
      const currentHourInJapan = moment.tz('Asia/Tokyo').hour();
      // Tạo mảng từ giờ hiện tại cộng 1 đến 23
      const hoursArray: number[] = [];
      for (let i: number = currentHourInJapan + 1; i <= 23; i++) {
        hoursArray.push(i);
      }
      return hoursArray;
    } else if (this.hourOptions && this.hourOptions.length > 0) {
      return this.hourOptions;
    } else {
      const hoursArray: number[] = [];
      for (let i: number = 0; i <= 23; i++) {
        hoursArray.push(i);
      }
      return hoursArray;
    }
  }

  checkBeforeToday(date) {
    return new Date(date.toDateString()) < new Date(new Date().toDateString());
  }

  closePopupTimePicker() {
    this.refDatePicker?.closePopup();
  }

  @Watch('disabledInput')
  private watchDisabledInput() {
    this.$nextTick(() => {
      this.closePopupTimePicker();
    });
  }
}
